<template>
  <form class="yakukyari_1st-jobsearch top_yakukyari_1st-jobsearch" id="yakukyari_1st-jobsearch" :action="path" accept-charset="UTF-8" method="post">
    <input type="hidden" name="pcr_content" :value="`${props.pcrContent}`">

    <div class="top_search-textbox search-textbox">
      <input type="text" class="top_use_lookup-icon use_lookup-icon" placeholder="例：企業名 気になるキーワードなど" id="form_office_search_form_text" :name="`${props.formParamsName}[keyword]`">
      <button type="submit" class="link_btn_green search_box_btn" ref="submit"><i class="fa-solid fa-magnifying-glass"></i></button>
    </div>

    <div :class="`top_search-contents_wrap search-contents_wrap ${section}`">
      <div class="search-contents_inner">
        <div class="search-contents search_icon_box">
          <a v-on:click.stop="currentPopup = 'Area'">
            <p class="top_search_icon search_icon"><img src="@assets/images/icon/img_search_icon_a.png" alt=""></p>
            <span>エリア</span>
          </a>
          <input type="hidden" :name="`${props.formParamsName}[prefecture_ids]`" v-model="prefectures">
        </div>

        <div class="search-contents search_icon_box">
          <a v-on:click.stop="currentPopup = 'Business'">
            <p class="top_search_icon search_icon"><img src="@assets/images/icon/img_search_icon_b.png" alt=""></p>
            <span>業種</span>
          </a>
          <input type="hidden" :name="`${props.formParamsName}[business_types]`" v-model="businessTypes">
        </div>

        <div v-if="!isCompany" class="search-contents search_icon_box">
          <a v-on:click.stop="currentPopup = 'Month'">
            <p class="top_search_icon search_icon"><img src="@assets/images/icon/img_search_icon_c.png" alt=""></p>
            <span>開催時期</span>
          </a>
          <input type="hidden" :name="`${props.formParamsName}[months]`" v-model="months">
        </div>
      </div>

      <a v-bind:href="props.recentSearchPath" class="top_search_link" v-if="props.pcRecentSearches">
        <div class="top_search_link_title">最近の検索</div>
        <div class="top_search_link_text">
          <span class="sp_hidden"><span>{{ props.pcRecentSearches }}</span></span>
          <span class="pc_hidden"><span>{{ props.spRecentSearches }}</span></span>
        </div>
      </a>
    </div>

    <div v-if="currentPopup" class="sub_search_wrap sub_search_heightMax">
      <AreaComponent v-if="currentPopup == 'Area'" @close="closePopup()" />
      <BusinessComponent v-if="currentPopup == 'Business'" @close="closePopup()" />
      <MonthComponent v-if="currentPopup == 'Month'" @close="closePopup()" />
      <div class="sub_search_wrap-modal-black-background"></div>
    </div>
  </form>
</template>

<script setup>
import { computed, provide, ref } from 'vue'
import AreaComponent from '@component_path/search-contents/top/components/area'
import BusinessComponent from '@component_path/search-contents/top/components/business'
import MonthComponent from '@component_path/search-contents/top/components/month'
/* composables */
import { useAreas } from '@component_path/composables/areas.js'
import { usePrefectures } from '@component_path/composables/prefectures.js'
import { useBusinessTypes } from '@component_path/composables/businessTypes.js'
import { useMonths } from '@component_path/composables/months.js'

const props = defineProps({
  tabName: { type: String, required: true },
  formParamsName: { type: String, required: true },
  areas: { type: Array, required: true },
  conditionTypes: { type: Array, required: true },
  prefectures: { type: Array, required: true },
  path: { type: String, required: true },
  clearAllAreas: { type: Object }, //条件クリア用
  pcRecentSearches: { type: String },
  spRecentSearches: { type: String },
  recentSearchPath: { type: String },
  pcrContent: { type: String }
})

/* data */
const currentPopup = ref(null)
const isCompany = computed(() => props.tabName == 'Company')
const section = computed(() => isCompany.value ? 'section-companies' : 'section-internships')

/* store */
const prefecturesStore = usePrefectures([], props.prefectures)
const areasStore = useAreas(prefecturesStore, props.clearAllAreas, props.areas, props.clearAllAreas)
const businessTypesStore = useBusinessTypes([], props.conditionTypes)
const monthsStore = useMonths([], [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
provide('areasStore', areasStore)
provide('businessTypesStore', businessTypesStore)
provide('monthsStore', monthsStore)

/* methods */
const closePopup = () => { currentPopup.value = null }

/* computed */
const prefectures = computed(() => prefecturesStore.prefectures.value)
const businessTypes = computed(() => businessTypesStore.businessTypes.value)
const months = computed(() => monthsStore.months.value)
</script>